import React from "react";
import Auth from "../../helpers/auth";
import { useSelector } from "react-redux";

const SchuelerListItem = ({ schueler, props }) => {
  const { setView, setActiveId } = props;
  
  const handleClick = (e) => {
    const { id } = e.target.parentElement;
    console.log(e.target, id)
    setActiveId(id);
    setView("details");
  };
  const user = useSelector(st => st.currentUser);
  const textA = `${schueler.nachname}, ${schueler.vorname} (${schueler.gesamtnote})`
  const textB = `${textA}  - ${schueler.id}`
  const text = Auth.isDeveloper(user.userStatus) ? textB : textA;
  return (
    <div key={schueler.id} id={schueler.id} onClick={(e) => handleClick(e)}>
      <h6>{text}</h6>
    </div>
  );
};
export default SchuelerListItem;
